import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import AccionesComunes from '../AccionesComunes';

class Normatividad extends Component {

    componentDidMount(){
        // document.title = "Ayuda | Normatividad";
        window.scrollTo(0, 0);
    }

    componentWillUnmount(){
        var colapsarMenu = document.getElementById("menuResponsivo");
        colapsarMenu.classList.replace("show", "not");
    }

    render () {
        return (
            <div className="container contenido">
                <AccionesComunes />
                <div className="migajas">
                    <small>
                        <Link to="./QueEsSIJE">Inicio</Link>
                        <span>Normatividad</span>
                    </small>
                </div>
                <div className="col-md-12 text-center mb-5">
                    <h1 className="tituloPagina">Normatividad</h1>
                </div>
                <div className="termino col-md-12">
                    <h3>Carta magna</h3>
                    <p><a href="http://www.diputados.gob.mx/LeyesBiblio/pdf_mov/Constitucion_Politica.pdf" target="_blank" rel="noopener noreferrer">Constitución Política de los Estados Unidos Mexicanos</a></p>
                </div>
                <div className="termino col-md-12">
                    <h3>Leyes generales</h3>
                    <p><a href="http://www.diputados.gob.mx/LeyesBiblio/pdf/LGIPE_130420.pdf" target="_blank" rel="noopener noreferrer">Ley General de Instituciones y Procedimientos Electorales</a></p>
                    <p><a href="http://www.diputados.gob.mx/LeyesBiblio/pdf/LGPP_130420.pdf" target="_blank" rel="noopener noreferrer">Ley General de Partidos Politicos</a></p>
                    {/* <p><a href="http://www.diputados.gob.mx/LeyesBiblio/pdf/239_310115.pdf" target="_blank" rel="noopener noreferrer">Ley del Sistema de Horario en los Estados Unidos Mexicanos.</a></p> */}
                </div>
                <div className="termino col-md-12">
                    <h3>Reglamentos</h3>
                    <p><a href="materials/Reglamento_INE_2020.pdf" target="_blank" rel="noopener noreferrer">Reglamento Interior del Instituto Nacional Electoral</a></p>
                    <p><a href="materials/INE-CG661-2016_Proyecto_DJ.pdf" target="_blank" rel="noopener noreferrer">Reglamento de Elecciones</a></p>
                </div>
                <div className="termino col-md-12">
                    <h3>Documentos Operativos</h3>
                    <p><a href="materials/Programa de Operación SIJE 2021.pdf" target="_blank" rel="noopener noreferrer">Programa de Operación del SIJE 2021</a></p>
                    <p><a href="materials/Manual de Operación SIJE 2021.pdf" target="_blank" rel="noopener noreferrer">Manual de Operación del SIJE 2021</a></p>
                </div>
            </div>
        )
    }
}

export default Normatividad;